import FAQSection from "@/components/custom/FaqSection";
import FeaturedProducts from "@/components/custom/FeaturedProducts";
import { Footer } from "@/components/custom/Footer";
import Contact from "@/components/custom/GetInTouch";
import HeroSection from "@/components/custom/HeroSection";
import StatsSection from "@/components/custom/StatsSection";
import { InternationalShippingGuide } from "@/components/custom/StepsAfterShipping";
import Testimonial from "@/components/custom/testimonial";
import { createFileRoute } from "@tanstack/react-router";
import ContactForm from "@/components/custom/ContactForm";
import { ButtonGroup } from "@/components/ui/button-group";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  //const { setCurrentChatId } = useChatStore();
  // const { data: visitorCount, isLoading, isError } = useVisitorCount();
  //const currentVisitorNumber = /* visitorCount ?? */ 0 + 1;
  //const handleNewChat = () => {};

  return (
    <div>
      {/*<div className="w-full bg-foreground text-background text-center py-3 text-sm sm:text-base font-medium">
         {isLoading && !isError ? (
          <span className="animate-pulse">Fetching today's visitors...</span>
        ) : (
          <>
            🚀 You are visitor number: <strong>{currentVisitorNumber}</strong> <br/>
            <p>Get a free T-Shirt with any Sweatsuit or Tracksuit order!</p>
          </>
        ) }
      </div>*/}
      <div className="rounded-lg backdrop-blur-xl shadow-xl px-4">
        <HeroSection />
      </div>

      {/* <div className="w-full bg-background rounded-lg backdrop-blur-xl shadow-xl px-4">
        <div className="max-w-2xl mx-auto text-center py-10">
          <Badge className="bg-gradient-to-br via-70% from-sky-500 via-muted/30 to-teal-500 text-foreground rounded-full py-1 border-none">
            Just released v1.0.0
          </Badge>
          <h1 className="mt-6 text-4xl sm:text-5xl md:text-6xl font-bold !leading-[1.2] tracking-tight">
            The First-Ever Chat to Shop Experience
          </h1>
          <p className="mt-6 text-[17px] md:text-lg">
            Shopping just got smarter. We're opening early access to a whole new
            way to browse, ask, and buy. All through a simple, intelligent chat.
            Try it now and be part of the future of online shopping.
          </p>
          <div className="mt-6 flex items-center justify-center gap-4">
            <Link to="/chat">
              <Button
                onClick={handleNewChat}
                size="lg"
                className="rounded-full text-base"
              >
                Get Started <ArrowUpRight className="!h-5 !w-5" />
              </Button>
            </Link>
            <a href="#features">
              <Button
                variant="outline"
                size="lg"
                className="rounded-full text-base shadow-none"
              >
                <CirclePlay className="!h-5 !w-5" /> Products
              </Button>
            </a>
          </div>
        </div>
      </div> */}

      <div
        id="company-info"
        className="mt-12 rounded-lg bg-white/70 backdrop-blur-xl shadow-xl px-6 py-10 text-center w-full mx-auto"
      >
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-black">
          Reliable. Fast. Global.
        </h1>
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-black">
          Your Trusted Logistics Partner.
        </h2>
        <p className="mt-4 text-base md:text-lg text-gray-700">
          Prime Capital Logistics offers comprehensive shipping management
          solutions designed to meet all your logistics needs with reliable
          service and 24/7 support from our dedicated team of professionals.
        </p>
        <h3 className="mt-8 text-xl font-semibold tracking-tight">Speak with our team</h3>
        <p className="mt-1 mb-4 text-muted-foreground text-sm">
          Available 24/7 for all your logistics needs.
        </p>
        <ButtonGroup className="mx-auto">
          <Button asChild variant="default">
            <a href={`tel:${import.meta.env.VITE_PHONE_NUMBER}`}>Call Us</a>
          </Button>
          <Button asChild variant="outline">
            <a href={`tel:${import.meta.env.VITE_TOLL_FREE_PHONE_NUMBER}`}>
              Call Toll Free
            </a>
          </Button>
        </ButtonGroup>
      </div>
      <div
        id="shipping-process"
        className=" mt-8 sm:mt-10 md:mt-12 rounded-lg  backdrop-blur-xl shadow-xl"
      >
        <InternationalShippingGuide />
      </div>
      <div
        id="features"
        className=" mt-8 sm:mt-10 md:mt-12 rounded-lg  backdrop-blur-xl shadow-xl"
      >
        <FeaturedProducts />
      </div>
      <div
        id="contact"
        className=" mt-8 sm:mt-10 md:mt-12 rounded-lg  backdrop-blur-xl shadow-xl"
      >
        <StatsSection />
      </div>
      <div
        id="testimonials"
        className=" mt-8 sm:mt-10 md:mt-12 rounded-lg  backdrop-blur-xl shadow-xl"
      >
        <Testimonial />
      </div>
      <div
        id="faq-section"
        className=" mt-8 sm:mt-10 md:mt-12 rounded-lg  backdrop-blur-xl shadow-xl"
      >
        <FAQSection />
      </div>
      <div
        id="company-details"
        className=" mt-8 sm:mt-10 md:mt-12 rounded-lg  backdrop-blur-xl shadow-xl"
      >
        <Contact />
      </div>
      <div
        id="contact-us"
        className=" mt-8 sm:mt-10 md:mt-12 rounded-lg  backdrop-blur-xl shadow-xl"
      >
        <ContactForm />
      </div>

      <Footer />
    </div>
  );
}
